import HJPlayer from './HJPlayer';
import Polyfill from './Utils/Polyfill';

Polyfill.install();

export default HJPlayer;
